import React from 'react';
import { useNavigate } from 'react-router-dom';
import heroBg from '../../assets/hero_bg.png';

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section className="relative w-full h-screen overflow-hidden flex items-center justify-center">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroBg} 
          alt="Classroom Background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
        {/* Top White Gradient for Navbar blending */}
        <div className="absolute inset-x-0 top-0 h-60 bg-gradient-to-b from-white via-white/500 to-transparent z-10"></div>
        {/* White Gradient Fade to next section */}
        <div className="absolute inset-x-0 bottom-0 h-60 bg-gradient-to-t from-white via-white/500 to-transparent z-10"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full max-w-4xl px-6 text-center text-white animate-fade-in">
        {/* Welcome Badge */}
        <div className="inline-block px-6 py-1.5 rounded-full bg-orange-600/30 backdrop-blur-md border border-orange-400/30 text-orange-100 text-sm font-bold uppercase tracking-widest mb-8">
          WELCOME TO KASUN WALAKUMBURA EDUCATION CENTER
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black uppercase tracking-tight mb-6 leading-none">
          KASUN <span className="text-orange-500">WALAKUMBURA</span>
        </h1>

        {/* Subtext */}
        <p className="font-sinhala text-lg md:text-xl text-slate-100/90 max-w-2xl mx-auto mb-12 font-medium leading-relaxed">
          ජයග්‍රහණය සඳහා බලපාන්නේ වාසනාවට වඩා උත්සාහයයි
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={() => navigate('/login')}
            className="w-full sm:w-auto px-10 py-4 bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold rounded-lg transition-all shadow-xl shadow-orange-900/40 hover:-translate-y-1 active:scale-95"
          >
            Get Started
          </button>
          <button className="w-full sm:w-auto px-10 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 text-white font-bold rounded-lg transition-all hover:-translate-y-1 active:scale-95">
            Learn More
          </button>
        </div>
      </div>

      {/* Slider Navigation UI - Visual Only */}
      <div className="hidden md:flex absolute inset-x-8 top-1/2 -translate-y-1/2 items-center justify-between z-20 pointer-events-none">
        <button className="w-12 h-12 rounded-lg bg-black/20 backdrop-blur-md flex items-center justify-center text-white/50 border border-white/10 pointer-events-auto hover:bg-black/40 hover:text-white transition-all cursor-pointer">
          ←
        </button>
        <button className="w-12 h-12 rounded-lg bg-black/20 backdrop-blur-md flex items-center justify-center text-white/50 border border-white/10 pointer-events-auto hover:bg-black/40 hover:text-white transition-all cursor-pointer">
          →
        </button>
      </div>

      {/* Pagination Dots - Visual Only */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-3 z-20">
        <div className="w-10 h-2 rounded-full bg-white transition-all"></div>
        <div className="w-2 h-2 rounded-full bg-white/30 hover:bg-white/60 transition-all cursor-pointer"></div>
        <div className="w-2 h-2 rounded-full bg-white/30 hover:bg-white/60 transition-all cursor-pointer"></div>
        <div className="w-2 h-2 rounded-full bg-white/30 hover:bg-white/60 transition-all cursor-pointer"></div>
        <div className="w-2 h-2 rounded-full bg-white/30 hover:bg-white/60 transition-all cursor-pointer"></div>
      </div>
    </section>
  );
};

export default HeroSection;
